import React from 'react';

interface Props {
  onClick?: () => void;
}

const WhiteOverlay: React.FC<Props> = ({ onClick }) => {
  //eslint-disable-next-line tailwindcss/no-custom-classname
  return <div className="fixed left-0 top-0 !z-[25] h-screen w-screen bg-white" onClick={onClick} />;
};

export default WhiteOverlay;
